import { SxProps, Theme } from '@mui/material';

export const toolbarContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 16px',
  backgroundColor: 'white',
  borderBottom: '1px solid #e0e0e0',
};

export const navigationContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const labelStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '1.1rem',
  ml: 2,
};

export const buttonStyles: SxProps<Theme> = {
  textTransform: 'none',
};

export const viewButtonStyles: SxProps<Theme> = {
  textTransform: 'capitalize',
};
